import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import ManageWorkers from "./pages/ManageWorkers";
import ManageJobs from "./pages/ManageJobs";
import ManageHelp from "./pages/ManageHelp";
import ManageCustomers from "./pages/ManageCustomers";
import PrivateRoute from "./components/PrivateRoute";
import WorkerProfilePage from "./pages/WorkerProfilePage";
import RideDocuments from "./pages/RideDocuments";
import AdminSupportChat from "./pages/AdminSupportChat";
import AdminSupportTickets from "./pages/AdminSupportTickets";
import DisputeJobs from "./pages/DisputeJobs";
import ManageRides from "./pages/ManageRides";
import SendEmail from "./pages/SendEmail";


import { Toaster } from "react-hot-toast";

const NotFound = () => (
  <div className="flex items-center justify-center h-screen">
    <h1 className="text-2xl font-bold text-red-600">404 - Page Not Found</h1>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* ✅ Public Routes */}
        <Route path="/" element={<AdminLogin />} />
        <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />

        {/* ✅ Protected Admin Routes */}
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/workers"
          element={
            <PrivateRoute>
              <ManageWorkers />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/manage-jobs"
          element={
            <PrivateRoute>
              <ManageJobs />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/help"
          element={
            <PrivateRoute>
              <ManageHelp />
            </PrivateRoute>
          }
        />
        <Route path="/admin/send-email" element={<SendEmail />} />
        <Route
          path="/admin/customers"
          element={
            <PrivateRoute>
              <ManageCustomers />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/disputes"
          element={
            <PrivateRoute>
              <DisputeJobs />
            </PrivateRoute>
          }
        />

        {/* ✅ Open (non-protected) admin tools */}
        <Route path="/admin/worker/:id" element={<WorkerProfilePage />} />
        <Route path="/admin/ride-documents" element={<RideDocuments />} />
        <Route path="/admin/support/live-chat" element={<AdminSupportChat />} />
        <Route path="/admin/support/tickets" element={<AdminSupportTickets />} />
        <Route path="/admin/manage-rides" element={<ManageRides />} />

        {/* 404 Fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* ✅ Global toaster for notifications */}
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
    </Router>
  );
}

export default App;
